module.exports = __webpack_public_path__ + "static/media/mp3.5d1d4ade.png";